export default __webpack_public_path__ + "static/1276-55cb367e0a031bd4f5a5099b365262dc.png";